/**
 * Утилиты для парсинга и обработки кодов маркировки
 */

/**
 * Парсинг GS1 DataMatrix кода и обрезка до стандартного формата (31 символ)
 * @param {string} code - Исходный код маркировки
 * @returns {string} - Обрезанный код в стандартном формате
 */
export const parseMarkingCode = (code) => {
    if (!code || typeof code !== 'string') {
        return code;
    }

    const trimmedCode = code.trim();
    console.log(`🔍 Парсинг кода: ${trimmedCode}`);

    // Парсим GS1 DataMatrix и обрезаем до стандартного формата
    // Формат: 01 (GTIN 14 цифр) + AI (2 цифры) + серийный номер (13 символов) = 31 символ
    const gs1Match = trimmedCode.match(/^01(\d{14})(\d\d)(.{13})/);
    if (gs1Match) {
        const gtin = gs1Match[1];
        const ai = gs1Match[2]; // Application Identifier (15, 21, etc.)
        const serialNumber = gs1Match[3]; // Первые 13 символов серийника

        const standardCode = `01${gtin}${ai}${serialNumber}`;
        console.log(`✅ Конвертирован в стандартный формат (31 символ): ${standardCode}`);

        return standardCode;
    }

    // Если не удалось парсить, используем как есть
    console.log(`⚠️ Используем исходный код (парсинг не удался): ${trimmedCode}`);
    return trimmedCode;
};

/**
 * Проверяет, является ли код в формате GS1 DataMatrix
 * @param {string} code - Код для проверки
 * @returns {boolean} - true если код в формате GS1
 */
export const isGS1Format = (code) => {
    if (!code || typeof code !== 'string') {
        return false;
    }
    return /^01\d{14}\d\d.{13}/.test(code.trim());
};

/**
 * Возвращает информацию о парсинге кода
 * @param {string} code - Исходный код
 * @returns {object} - Детальная информация о коде
 */
export const getCodeInfo = (code) => {
    if (!code || typeof code !== 'string') {
        return {
            original: code,
            parsed: code,
            isGS1: false,
            gtin: null,
            ai: null,
            serial: null
        };
    }

    const trimmedCode = code.trim();
    const gs1Match = trimmedCode.match(/^01(\d{14})(\d\d)(.{13})/);

    if (gs1Match) {
        return {
            original: trimmedCode,
            parsed: `01${gs1Match[1]}${gs1Match[2]}${gs1Match[3]}`,
            isGS1: true,
            gtin: gs1Match[1],
            ai: gs1Match[2],
            serial: gs1Match[3],
            length: `01${gs1Match[1]}${gs1Match[2]}${gs1Match[3]}`.length
        };
    }

    return {
        original: trimmedCode,
        parsed: trimmedCode,
        isGS1: false,
        gtin: null,
        ai: null,
        serial: null,
        length: trimmedCode.length
    };
};

export default {
    parseMarkingCode,
    isGS1Format,
    getCodeInfo
};